// @flow
import Popup from '../DynamicBase';

import * as RingSizeSelection from '@components/popups/content/RingSizeSelection';

import WatchClickOutside from '@components/WatchClickOutside';

type PropsType = {
  show: boolean,
  onCloseClick: () => void,
  anchorElement?: HTMLElement | null
};

export default (props: PropsType) => {
  return (
    <WatchClickOutside onClickOutside={props.onCloseClick}>
      <Popup
        show={props.show}
        onCloseClick={props.onCloseClick}
        onClick={e => e.stopPropagation()}
        anchorElement={props.anchorElement}
        initialContent={RingSizeSelection}
      />
    </WatchClickOutside>
  );
};
